/** Sadarat master gender (matches API `SadaratGender`). */
export type SadaratGender = "MALE" | "FEMALE";

export const SADARAT_GENDER_CHOICES: { id: SadaratGender; name: string }[] = [
  { id: "MALE", name: "Male" },
  { id: "FEMALE", name: "Female" },
];

/**
 * Map ITS directory `Gender` to sadarat gender (same Male/Female token rules as miqaat RSVP).
 * Female checked first so tokens stay unambiguous.
 */
export function itsGenderToSadaratGender(gender: unknown): SadaratGender | null {
  const u = String(gender ?? "")
    .trim()
    .toUpperCase();
  if (!u) return null;
  if (u === "F" || u === "FEMALE" || u.startsWith("FEMALE")) return "FEMALE";
  if (u === "M" || u === "MALE" || u.startsWith("MALE")) return "MALE";
  return null;
}
